import { render, staticRenderFns } from "./VehicleBulkUpload.vue?vue&type=template&id=8402aaec&scoped=true&"
import script from "./VehicleBulkUpload.vue?vue&type=script&lang=js&"
export * from "./VehicleBulkUpload.vue?vue&type=script&lang=js&"
import style0 from "./VehicleBulkUpload.vue?vue&type=style&index=0&id=8402aaec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8402aaec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
